import { render, staticRenderFns } from "./demandSuggest.vue?vue&type=template&id=f18090ce&scoped=true&"
import script from "./demandSuggest.vue?vue&type=script&lang=js&"
export * from "./demandSuggest.vue?vue&type=script&lang=js&"
import style0 from "./demandSuggest.vue?vue&type=style&index=0&id=f18090ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18090ce",
  null
  
)

export default component.exports